export function checkDashboardsPath(target) {
    return window.location.pathname == `/dashboards` ? target : '.none'
}
export function checkShowListPath(target) {
    return window.location.pathname == `/clients/payroll_rules_groups` ? target : '.none'
}
export function checkCreatePath(target) {
    return window.location.pathname == `/clients/payroll_rules_groups/new` ? target : '.none'
}